/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./../lib/httpClient.ts";
import {
  CreateModulePageDefinitionRequestDTO,
  Response,
  UpdateModulePageDefinitionRequestDTO,
} from "././index.d.ts";

export class Modules<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get module page definition by record id.
   *
   * @tags uimanager
   * @name GetModulePageDefinition
   * @request GET:/modules/{id}
   * @secure
   */
  getModulePageDefinition = (id: string, params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/modules/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing module page definition.
   *
   * @tags uimanager
   * @name UpdateModulePageDefinition
   * @request PUT:/modules/{id}
   * @secure
   */
  updateModulePageDefinition = (
    id: string,
    data: UpdateModulePageDefinitionRequestDTO,
    params: RequestParams = {},
  ) =>
    this.http.request<Response, Response>({
      path: `/modules/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Return all module page definitions ordered by last update time descending.
   *
   * @tags uimanager
   * @name ListModulePageDefinition
   * @request GET:/modules
   * @secure
   */
  listModulePageDefinition = (params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/modules`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a module default page configuration for one onboarded module.
   *
   * @tags uimanager
   * @name CreateModulePageDefinition
   * @request POST:/modules
   * @secure
   */
  createModulePageDefinition = (
    data: CreateModulePageDefinitionRequestDTO,
    params: RequestParams = {},
  ) =>
    this.http.request<Response, Response>({
      path: `/modules`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Import module configuration bundle from an uploaded JSON file. File JSON mirrors export structure but excludes system-managed fields (`id`, `createdAt`, `updatedAt`, `createdBy`, `createdName`, `updatedBy`, `updatedName`). Upserts by business key: module by `module`, menu by `menuId`, page by `pageId`, view by `viewId`. The `module` and optional `description` form fields are applied to the imported module page definition.
   *
   * @tags uimanager
   * @name ImportModulePageDefinition
   * @request POST:/modules/import
   * @secure
   */
  importModulePageDefinition = (
    query: {
      /**
       * Applicable module to import configuration for; applied to the module page definition.
       * @minLength 0
       * @maxLength 50
       */
      module: string;
      /** Optional description applied to the module page definition. */
      description?: string;
    },
    data: {
      /**
       * JSON file containing `ModuleConfigurationImport` structure.
       * @format binary
       */
      file: File;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<Response, Response>({
      path: `/modules/import`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Export module page configuration bundle as a downloadable JSON file for the specified module.
   *
   * @tags uimanager
   * @name ExportModulePageDefinition
   * @request GET:/modules/export
   * @secure
   */
  exportModulePageDefinition = (
    query: {
      /**
       * Applicable module to export configuration for.
       * @minLength 0
       * @maxLength 50
       */
      module: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<File, Response>({
      path: `/modules/export`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
}
